import React, { Suspense } from 'react';
import { Dialog, Spinner, Flex } from 'core/components';
import DialogBody from 'core/components/DialogBody';

const TextPanelInlineEditor = React.lazy(
  () => import(/* webpackChunkName: "text-panel-editor" */ './TextPanelInlineEditor')
);

function TextPanelEditorDialog({ isOpen, config, onSave, onCancel }) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onCancel}
      title="Edit Text Panel"
      height={600}
      width={900}
      my={50}
      maxHeight="calc(100vh - 100px)"
    >
      {isOpen && config && (
        <DialogBody p={0} display="flex" flex={1} overflow="hidden">
          <Suspense
            fallback={
              <Flex flex={1} alignItems="center" justifyContent="center">
                <Spinner />
              </Flex>
            }
          >
            <TextPanelInlineEditor config={config} onSave={onSave} onCancel={onCancel} />
          </Suspense>
        </DialogBody>
      )}
    </Dialog>
  );
}

export default TextPanelEditorDialog;
